"use strict";
const { LINK_TYPES: { WEB }, } = require('../../constants');
exports.generateWebLink = ({ content }) => ({
    type: WEB,
    content,
});
//# sourceMappingURL=linkFactory.js.map